import React, { createContext, useContext } from 'react';
import {
  formatCurrency,
  formatPrice,
  formatPriceWithoutSymbol,
  formatPriceCompact,
  formatPriceRange,
  formatDiscount,
  getCurrencySymbol,
  getCurrencyCode,
  getCurrencyName,
  formatIndianNumber,
  isValidAmount
} from '../utils/currency';

const CurrencyContext = createContext();

export const useCurrency = () => {
  const context = useContext(CurrencyContext);
  if (!context) {
    throw new Error('useCurrency must be used within a CurrencyProvider');
  }
  return context;
};

export const CurrencyProvider = ({ children }) => {
  const value = {
    formatCurrency,
    formatPrice,
    formatPriceWithoutSymbol,
    formatPriceCompact,
    formatPriceRange,
    formatDiscount,
    getCurrencySymbol,
    getCurrencyCode,
    getCurrencyName,
    formatIndianNumber,
    isValidAmount,
    currency: {
      code: 'INR',
      symbol: '₹',
      name: 'Indian Rupee'
    }
  };

  return (
    <CurrencyContext.Provider value={value}>
      {children}
    </CurrencyContext.Provider>
  );
};

